import { render, staticRenderFns } from "./ProDeskReportingNavigation.vue?vue&type=template&id=636121b7&scoped=true"
import script from "./ProDeskReportingNavigation.vue?vue&type=script&lang=js"
export * from "./ProDeskReportingNavigation.vue?vue&type=script&lang=js"
import style0 from "./ProDeskReportingNavigation.vue?vue&type=style&index=0&id=636121b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636121b7",
  null
  
)

export default component.exports